'use client'
import { ProductReviewsBlock } from 'cms-types'
import { useSearchParams } from 'next/navigation'
import { Suspense } from 'react'
import { ProductReviews as ProductReviewsUI, ProductVariant } from 'ui'

import { useGlobalTypography } from '@/store/globalTypographyStore'

type ProductReviewsProps = ProductReviewsBlock & {
  variants: ProductVariant[]
}

// useSearchParams makes the closest Suspense boundary client-side rendered on static pages, so
// keep that boundary around this block only and server render the default variant's reviews.
// See https://nextjs.org/docs/app/api-reference/functions/use-search-params#prerendering
export default function ProductReviews(props: ProductReviewsProps) {
  return (
    <Suspense fallback={<Reviews {...props} selectedVariant={props.variants[0]} />}>
      <ReviewsForUrlVariant {...props} />
    </Suspense>
  )
}

function ReviewsForUrlVariant(props: ProductReviewsProps) {
  const variantId = useSearchParams().get('variant')

  return <Reviews {...props} selectedVariant={props.variants.find(({ id }) => id === variantId)} />
}

function Reviews({
  selectedVariant,
  ...props
}: ProductReviewsProps & { selectedVariant: ProductVariant | undefined }) {
  const typography = useGlobalTypography(state => state.productPage)

  return (
    <ProductReviewsUI
      {...props}
      selectedVariant={selectedVariant}
      typography={typography}
      reviewsStore={process.env.NEXT_PUBLIC_REVIEWS_STORE}
    />
  )
}
